import customer from './fragmentCustomer.gql';

const accountActivate = (
	`query($accessToken: String!) {
	  customer(customerAccessToken: $accessToken) ${customer}
	}`
);

export default accountActivate;
